<template>
  <el-collapse>
    <el-collapse-item>
      <template #title>
        <el-text class="mx-1 arc-orange-font" tag="b" size="large"><el-icon><DataAnalysis /></el-icon> DASHBOARD</el-text>
      </template>
      <el-row :gutter="10" :class="type === 'campus' ? '' : 'mt-2'">
        <el-col :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8"></el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Changes in Risk Ratings Through Time"
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart">
              <SankeyChart
                chartId="riskPrePostAdaptChart"
                :isDataLoading="loadState"
                :isDataLoaded="dataLoaded"
                :chartData="riskRatingChangesData"
                :chartOptions="riskRatingChangesOptions"
              />
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8"></el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Number of risks their ratings before and after adaptation."
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart">
              <BarChart
                chartId="riskPrePostAdaptChart"
                :isDataLoading="loadState"
                :isDataLoaded="dataLoaded"
                :chartData="riskPrePostAdaptData"
                :chartOptions="riskPrePostAdaptChartOptions"
              />
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8">
                <el-select
                  v-model="selectedRiskChartTerm"
                  placeholder="Select Term"
                  size="small"
                  filterable
                >
                  <el-option
                    v-for="item in termSelection"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Proportion of climate risk ratings across each future timescale."
                >
                  <template #reference>
                    <el-button circle >
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart">
              <PieChart
                chartId="riskProportionChart"
                :chartData="rikProportionData"
                :chartOptions="riskProportionOptions"
              />
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mt-2">
        <el-col :span="8">
          <el-card class="adaptation-table-card">
            <el-row justify="space-between">
              <el-col :span="8"></el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Percentage of Adaptations complete across time periods."
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class="adaptation-table-title my-3"><el-icon><TrendCharts /></el-icon>Adaptation Actions</div>
            <el-table :data="adaptationActionTable" :cell-class-name="cellClass">
              <el-table-column prop="timing" label="Timing" width="190">
                <template #default="scope">
                  <div class="timing-column">{{ scope.row.timing }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="count" label="Count" />
              <el-table-column prop="implemented" label="Implemented" width="115"/>
              <el-table-column prop="percent" label="%" />
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8"></el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Graph of the different Adaptation categories."
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart">
              <PieChart
                chartId="adaptationActionChart"
                :chartData="adaptationActionData"
                :chartOptions="adaptationActionOptions"
              />
            </div>
          </el-card>
        </el-col>
        <el-col v-if="type !== 'enterprise'" :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8">
                <el-select
                  v-model="selectedHazardChartTerm"
                  placeholder="Select Term"
                  size="small"
                  filterable
                >
                  <el-option
                    v-for="item in termSelection"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Summary of risk ratings associated with each key climate change hazard."
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart">
              <BarChart
                chartId="hazardChart"
                :isDataLoading="loadState"
                :chartData="hazardData"
                :chartOptions="hazardOptions"
              />
            </div>
          </el-card>
        </el-col>
        <el-col v-else :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8">
                <el-select
                  v-model="selectedRiskRatingByConsequenceChartChartTerm"
                  placeholder="Select Term"
                  size="small"
                  filterable
                >
                  <el-option
                    v-for="item in termSelection"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Summary of risk ratings associated with each consequence area hazard."
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart">
              <BarChart
                chartId="riskRatingByConsequenceChart"
                :isDataLoading="loadState"
                :chartData="riskRatingByConsequenceData"
                :chartOptions="riskRatingByConsequenceOptions"
              />
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row v-if="type !== 'enterprise'" :gutter="10" class="mt-2">
        <el-col v-if="type === 'campus'" :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8">
                <el-select
                  v-model="selectedSubAssetChartTerm"
                  placeholder="Select Term"
                  size="small"
                  filterable
                >
                  <el-option
                    v-for="item in termSelection"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Summary of risk ratings associated with different asset components."
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart sub-asset-chart-container">
              <BarChart
                chartId="subAssetChart"
                :isDataLoading="loadState"
                :chartData="subAssetData"
                :chartOptions="subAssetOptions"
                cssClasses="sub-asset-chart"
              />
              <!-- <DoughnutChart
                :chartData="subAssetData"
                :chartOptions="subAssetOptions"
              /> -->
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8">
                <el-select
                  v-model="selectedHazardCombinedChartTerm"
                  placeholder="Select Term"
                  size="small"
                  filterable
                >
                  <el-option
                    v-for="item in termSelection"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Summary of risk ratings associated with each key climate change hazard."
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart">
              <DoughnutChart
                chartId="hazardCombinedChart"
                :chartData="hazardCombinedData"
                :chartOptions="hazardCombinedOptions"
              />
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card>
            <el-row justify="space-between">
              <el-col :span="8"></el-col>
              <el-col :span="2">
                <el-popover
                  placement="bottom"
                  title=""
                  :width="300"
                  trigger="click"
                  content="Summary of risk ratings associated with each key climate change hazard."
                >
                  <template #reference>
                    <el-button circle>
                      <el-icon><QuestionFilled /></el-icon>
                    </el-button>
                  </template>
                </el-popover>
              </el-col>
            </el-row>
            <div class= "small-chart">
              <PieChart
                chartId="hazardPieChart"
                :chartData="hazardPieData"
                :chartOptions="hazardPieOptions"
              />
            </div>
          </el-card>
        </el-col>
        <el-col v-if="type !== 'campus'" :span="8" style="align-self: center;">
          <el-card style="min-height: 388px;">
            <div class= "small-chart">
              <BarChart
                chartId="adaptationImplementationBarChart"
                :chartData="adaptationImplementationBarData"
                :chartOptions="adaptationCompletionBarChartOptions"
              />
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div v-if="type !== 'campus'">
        <el-row :gutter="10" class="mt-2">
          <el-col :span="24">
            <el-card style="max-height: 356px; overflow-y: auto;">
              <el-row justify="space-between">
                <el-col :span="8"></el-col>
                <el-col :span="2">
                  <el-popover
                    placement="bottom"
                    title=""
                    :width="300"
                    trigger="click"
                    content="Consolidated child risk rating summary."
                  >
                    <template #reference>
                      <el-button circle>
                        <el-icon><QuestionFilled /></el-icon>
                      </el-button>
                    </template>
                  </el-popover>
                </el-col>
              </el-row>
              <div class= "wide-chart">
                <BarChart
                  chartId="childRiskSummary"
                  :isDataLoading="loadState"
                  :isDataLoaded="dataLoaded"
                  :chartData="childRiskSummaryData"
                  :chartOptions="childRiskSummaryChartOptions"
                  :enableSeparators="true"
                  :height="`${initialCRAList.length * 28 + 74}px`"
                />
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
/*eslint-disable */
import { QuestionFilled, DataAnalysis, TrendCharts } from '@element-plus/icons-vue'
import PieChart from './charts/PieChart.vue';
import BarChart from './charts/BarChart.vue';
import DoughnutChart from './charts/DoughnutChart.vue';
import SankeyChart from './charts/SankeyChart.vue';

export default {
  name: "Dashboard",
  components: {
    PieChart,
    QuestionFilled,
    BarChart,
    DoughnutChart,
    DataAnalysis,
    SankeyChart,
    TrendCharts,
  },
  props: ["childRiskSummary", "initialCRAList", "adaptationData", "type"],
  data() {
    return {
      loadState: false,
      dataLoaded: true,
      childRiskSummaryChartOptions: {
        indexAxis: 'y',
        // barThickness: 'flex',
        // barPercentage: 1,
        // categoryPercentage: 0.5,
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              display: false
            }
          },
          y: {
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              display: true,
              font: {
                size: 10,
              },
            }
          },
        },
        plugins: {
          title: {
            text: 'Consolidated child risk rating summary',
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 10,
              font: {
                size: 9
              }
            }
          },
          separatorLines: {
            display: true
          },
          tooltip: {
              callbacks: {
                  title: function(tooltipItem) {
                      return tooltipItem.raw;
                  }
              }
          }

        },
        maintainAspectRatio: false,
      },
      riskPrePostAdaptChartOptions: {
        scales: {
          x: {
            grid: {
              display: false
            },
          },
          y: {
            grid: {
              display: false
            },
            ticks: {
              display: false
            }
          },
        },
        plugins: {
          title: {
            text: 'Risk rating pre/post adaptation',
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          legend: {
            position: 'left',
            labels: {
              boxWidth: 10,
              font: {
                size: 9
              }
            }
          }
        },
        maintainAspectRatio: false,
      },
      riskProportionOptions: {
        plugins: {
          title: {
            text: "Risk proportion by time and rating",
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          legend: {
            display: true,
            position: "left",
            labels: {
              fontStyle: 'bold',
              fontFamily: 'Segoe UI'
            }
          },
          maintainAspectRatio: true,
          responsive: true,
        }
      },
      termSelection: [
        { label: "Short Term", value: "st" },
        { label: "Long Term", value: "lt" },
      ],
      selectedRiskChartTerm: "st",
      hazardOptions: {
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            },
          },
          y: {
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              display: false
            }
          },
        },
        plugins: {
          title: {
            text: "Risk ratings by climate hazard",
            display: true,
            font: {
              family: "Segoe UI",
              size: 15,
              weight: "bold",
              lineHeight: 1.2,
            },
          },
          legend: {
            position: "left",
            labels: {
              boxWidth: 10,
              font: {
                size: 9
              }
            }
          }
        },
        maintainAspectRatio: false,
      },
      selectedHazardPieChartTerm: "st",
      hazardPieOptions: {
        plugins: {
          title: {
            text: "Sources (climate hazards) of moderate, high and very high risks",
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          legend: {
            display: true,
            position: "left",
            labels: {
              fontStyle: 'bold',
              fontFamily: 'Segoe UI'
            }
          },
          maintainAspectRatio: true,
          responsive: true,
        }
      },
      selectedHazardChartTerm: "st",
      subAssetOptions: {
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            },
          },
          y: {
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              display: false
            }
          },
        },
        plugins: {
          title: {
            text: "Risk ratings by asset level 2 component",
            display: true,
            font: {
              family: "Segoe UI",
              size: 15,
              weight: "bold",
              lineHeight: 1.2,
            },
          },
          legend: {
            position: "left",
            labels: {
              boxWidth: 10,
              font: {
                size: 9
              }
            }
          }
        },
        maintainAspectRatio: false,
        /* config for doughnut chart
        plugins: {
          title: {
            text: "Sub asset components with moderate, high and very high risks",
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          legend: {
            display: true,
            position: "left",
            labels: {
              fontStyle: 'bold',
              fontFamily: 'Segoe UI'
            }
          },
          tooltips: {
            enabled: true,
            callbacks: {
              title: function(tooltipItem, data) {
                return data.datasets[tooltipItem[0]['datasetIndex']].label;
              }
            }
          },
          maintainAspectRatio: true,
          responsive: true,
        }
        */
      },
      selectedSubAssetChartTerm: "st",
      hazardCombinedOptions: {
        plugins: {
          title: {
            text: "Sources (climate hazards) of moderate, high and very high risks",
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          legend: {
            display: true,
            position: "left",
            labels: {
              fontStyle: 'bold',
              fontFamily: 'Segoe UI'
            }
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function(tooltipItem) {
                const value = tooltipItem.raw
                const total = tooltipItem?.dataset.data.reduce(function(previousValue, currentValue) {
                  return previousValue + currentValue;
                });
                if (!total) {
                  return "0%"
                }
                const percentage = value / total * 100
                return `${tooltipItem.label}: ${Math.round((percentage + Number.EPSILON) * 100) / 100}%`;
              }
            }
          },
          maintainAspectRatio: true,
          responsive: true,
        }
      },
      selectedHazardCombinedChartTerm: "st",
      riskRatingChangesOptions: {
        plugins: {
          title: {
            text: "Changes in Risk Ratings Through Time",
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function(tooltipItem) {
                // format "from" label
                const tempFrom = tooltipItem.raw.from.split("_")
                tempFrom.pop()
                const from = tempFrom.map(string => string[0].toUpperCase() + string.slice(1)).join(" ")

                // format "to" label
                const tempTo = tooltipItem.raw.to.split("_")
                tempTo.pop()
                const to = tempTo.map(string => string[0].toUpperCase() + string.slice(1)).join(" ")

                return `${from} -> ${to}: ${tooltipItem.raw.flow}`
              }
            }
          },
          maintainAspectRatio: false,
          responsive: true,
        }
      },
      adaptationActionOptions: {
        plugins: {
          title: {
            text: "Percentage of Adaptations incomplete",
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          legend: {
            display: true,
            position: "left",
            labels: {
              fontStyle: 'bold',
              fontFamily: 'Segoe UI'
            }
          },
          maintainAspectRatio: true,
          responsive: true,
        }
      },
      selectedRiskRatingByConsequenceChartChartTerm: "st",
      riskRatingByConsequenceOptions: {
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            },
          },
          y: {
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              display: false
            }
          },
        },
        plugins: {
          title: {
            text: "Risk ratings by consequence area",
            display: true,
            font: {
              family: "Segoe UI",
              size: 15,
              weight: "bold",
              lineHeight: 1.2,
            },
          },
          legend: {
            position: "left",
            labels: {
              boxWidth: 10,
              font: {
                size: 9
              }
            }
          }
        },
        maintainAspectRatio: false,
      },
      adaptationCompletionBarChartOptions: {
        indexAxis: 'y',
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              display: false
            }
          },
          y: {
            stacked: true,
            grid: {
              display: false
            },
            ticks: {
              display: true,
              font: {
                size: 10,
              },
            }
          },
        },
        plugins: {
          title: {
            text: 'Adaptation Implementation Timing',
            display: true,
            font: {
              family: 'Segoe UI',
              size: 15,
              weight: 'bold',
              lineHeight: 1.2,
            },
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 10,
              font: {
                size: 9
              }
            }
          },
          separatorLines: false
        },
        maintainAspectRatio: false,
      },
    }
  },
  computed: {
    adaptationImplementationBarDataSet() {
      const returnVal = [
        {
          label: 'Complete',
          backgroundColor: '#46D267',
          data: []
        },
        {
          label: 'Incomplete',
          backgroundColor: '#DD4B39',
          data: []
        },
      ];
      
      const priority = {
        very_high_priority: 0,
        high_priority: 0,
        medium_priority: 0,
        low_priority: 0,
        very_low_priority: 0,
      }

      const data = {
        Complete: structuredClone(priority),
        Incomplete: structuredClone(priority),
      }
      
      this.adaptationData?.forEach(adaptation => {
        const currentStat = adaptation.completed ? 'Complete' : 'Incomplete'
        
        data[currentStat][adaptation.adaptation_timing] ++
      });

      Object.keys(data)?.forEach(dataset => {
        const foundObj = returnVal.find(val => val.label == dataset)
        const index = returnVal.indexOf(foundObj);
        returnVal[index].data = Object.values(data[dataset])
      })

      return returnVal;
    },
    adaptationImplementationBarData() {
      return {
        labels: [
          'Very high priority (<1 year)',
          'High priority (1-5 years)',
          'Medium priority (5-10 year)',
          'Low priority (10-20 years)',
          'Very low priority (20+ years)'
        ],
        datasets: this.adaptationImplementationBarDataSet
      }
    },
    childRiskSummaryDataSet() {
      const returnVal = [
        {
          label: 'Very Low',
          data: [],
          backgroundColor: "rgba(40, 167, 69, 0.2)",
        },
        {
          label: 'Low',
          data: [],
          backgroundColor: "rgba(40, 167, 69, 0.5)",
        },
        {
          label: 'Moderate',
          data: [],
          backgroundColor: "rgba(255, 193, 7, 0.5)",
        },
        {
          label: "High",
          backgroundColor: "rgba(255, 153, 0, 0.5)",
          data: [],
        },
        {
          label: "Very High",
          backgroundColor: "rgba(221, 75, 57, 0.5)",
          data: [],
        },
        {
          label: "No Rating",
          backgroundColor: "rgba(108, 117, 125, 0.5)",
          data: [],
        },
      ]

      this.childRiskSummary?.forEach(riskSummary => {
        returnVal[0].data.push(riskSummary.risk_ratings.very_low)
        returnVal[1].data.push(riskSummary.risk_ratings.low)
        returnVal[2].data.push(riskSummary.risk_ratings.moderate)
        returnVal[3].data.push(riskSummary.risk_ratings.high)
        returnVal[4].data.push(riskSummary.risk_ratings.very_high)
        returnVal[5].data.push(riskSummary.risk_ratings.no_rating)
      });

      return returnVal
    },
    childRiskSummaryData() {
      return {
        labels: this.childRiskSummary?.map(riskSummary => {
          const index = riskSummary.risk_statement.slice(0, riskSummary.risk_statement.length/2).lastIndexOf(' ')
          return [
            riskSummary.risk_statement.slice(0, index),
            riskSummary.risk_statement.slice(index)
          ]
        }),
        datasets: this.childRiskSummaryDataSet,
      }
    },
    riskProportionDataSet() {
      let field = "lt_climate_risk_rating_code"
      if (this.selectedRiskChartTerm === "st") {
        field = "st_climate_risk_rating_code"
      }

      let vlCount = 0
      let lCount = 0
      let mCount = 0
      let hCount = 0
      let vhCount = 0

      this.initialCRAList.forEach(cra => {
        if (cra[field] === "very_low") {
          vlCount ++
        } else if (cra[field] === "low") {
          lCount ++
        } else if (cra[field] === "moderate") {
          mCount ++
        } else if (cra[field] === "high") {
          hCount ++
        } else if (cra[field] === "very_high") {
          vhCount ++
        }
      });

      return [vlCount, lCount, mCount, hCount, vhCount]
    },
    rikProportionData() {
      return {
        labels: ['Very Low', 'Low', 'Moderate', 'High', 'Very High'],
        datasets: [
          {
            backgroundColor: ['#46d267', '#28a745', '#ffc107', '#FF9900', '#dd4b39'],
            data: this.riskProportionDataSet,
          }
        ]
      }
    },
    riskPrePostAdaptDataSet() {
      // define property names
      const riskLT = "lt_climate_risk_rating_code"
      const riskST = "st_climate_risk_rating_code"
      const adaptLT = "lt_risk_treatment_rating_code"
      const adaptST = "st_risk_treatment_rating_code"

      // initialize counts
      const riskLTCount = {
        very_low: 0,
        low: 0,
        moderate: 0,
        high: 0,
        very_high: 0
      }
      const adaptLTCount = {
        very_low: 0,
        low: 0,
        moderate: 0,
        high: 0,
        very_high: 0
      }
      const riskSTCount = {
        very_low: 0,
        low: 0,
        moderate: 0,
        high: 0,
        very_high: 0
      }
      const adaptSTCount = {
        very_low: 0,
        low: 0,
        moderate: 0,
        high: 0,
        very_high: 0
      }

      // loop through data to total
      this.initialCRAList.forEach(cra => {
        // tally long term climate risk
        riskLTCount[cra[riskLT]] ++
        // tally long term climate risk adaptation
        adaptLTCount[cra[adaptLT]] ++
        // tally short term climate risk
        riskSTCount[cra[riskST]] ++
        // tally short term climate risk adaptation
        adaptSTCount[cra[adaptST]] ++
      });

      return [
        {
          label: 'Very Low',
          data: [riskSTCount.very_low, riskLTCount.very_low],
          backgroundColor: "rgba(40, 167, 69, 0.2)",
          stack: 'Risk',
        },
        {
          label: 'Low',
          data: [riskSTCount.low,riskLTCount.low],
          backgroundColor: "rgba(40, 167, 69, 0.5)",
          stack: 'Risk',
        },
        {
          label: 'Moderate',
          data: [riskSTCount.moderate, riskLTCount.moderate],
          backgroundColor: "rgba(255, 193, 7, 0.5)",
          stack: 'Risk',
        },
        {
          label: "High",
          backgroundColor: "rgba(255, 153, 0, 0.5)",
          data: [riskSTCount.high, riskLTCount.high],
          stack: 'Risk'
        },
        {
          label: "Very High",
          backgroundColor: "rgba(221, 75, 57, 0.5)",
          data: [riskSTCount.very_high, riskLTCount.very_high],
          stack: 'Risk'
        },
        {
          label: 'Adaptation Very Low',
          data: [
            adaptSTCount.very_low + riskSTCount.very_low,
            adaptLTCount.very_low + riskLTCount.very_low,
          ],
          backgroundColor: "#46d267",
          stack: 'Adaptation',
        },
        {
          label: 'Adaptation Low',
          data: [
            adaptSTCount.low + riskSTCount.low,
            adaptLTCount.low + riskLTCount.low,
          ],
          backgroundColor: "#28a745",
          stack: 'Adaptation',
        },
        {
          label: 'Adaptation Moderate',
          data: [
            adaptSTCount.moderate + riskSTCount.moderate,
            adaptLTCount.moderate + riskLTCount.moderate,
          ],
          backgroundColor: "#ffc107",
          stack: 'Adaptation',
        },
        {
          label: "Adaptation High",
          backgroundColor: "#FF9900",
          data: [
            adaptSTCount.high + riskSTCount.high,
            adaptLTCount.high + riskLTCount.high,
          ],
          stack: 'Adaptation'
        },
        {
          label: "Adaptation Very High",
          backgroundColor: "#dd4b39",
          data: [
            adaptSTCount.very_high + riskSTCount.very_high,
            adaptLTCount.very_high + riskLTCount.very_high,
          ],
          stack: 'Adaptation'
        },
      ]
    },
    riskPrePostAdaptData() {
      return {
        labels: ['Short Term', 'Long Term'],
        datasets: this.riskPrePostAdaptDataSet,
      }
    },
    hazardDataSet() {
      // initialize data
      const riskRatings = {
        no_rating: 0,
        very_low: 0,
        low: 0,
        moderate: 0,
        high: 0,
        very_high: 0,
      }
      const data = {
        bushfire: structuredClone(riskRatings),
        drought: structuredClone(riskRatings),
        flooding: structuredClone(riskRatings),
        heatwaves: structuredClone(riskRatings),
        increased_rainfall_intensity: structuredClone(riskRatings),
        sea_level_rise: structuredClone(riskRatings),
        storms: structuredClone(riskRatings),
        extreme_heat: structuredClone(riskRatings),
      }
      
      let field = "lt_climate_risk_rating_code"
      if (this.selectedHazardChartTerm === "st") {
        field = "st_climate_risk_rating_code"
      }

      // populate data
      this.initialCRAList.forEach(cra => {
        const ratings = Object.keys(riskRatings)
        // remove first one "no_rating"
        ratings.shift()

        // loop through climate variables
        cra.climate_variables.forEach(climateVariable => {
          if (ratings.includes(cra[field])) {
            data[climateVariable][cra[field]] ++
          } else if (data[climateVariable]) {
            data[climateVariable].no_rating ++
          }
        })
      });

      const labelDetails = [
        { label: "No Rating", rating: "no_rating", backgroundColor: "#6C757D" },
        { label: "Very Low", rating: "very_low", backgroundColor: "#46D267" },
        { label: "Low", rating: "low", backgroundColor: "#28A745" },
        { label: "Moderate", rating: "moderate", backgroundColor: "#FFC107" },
        { label: "High", rating: "high", backgroundColor: "#FF9900" },
        { label: "Very High", rating: "very_high", backgroundColor: "#DD4B39" },
      ]
      const subAssets = [
        "bushfire",
        "drought",
        "flooding",
        "heatwaves",
        "increased_rainfall_intensity",
        "sea_level_rise",
        "storms",
        "extreme_heat",
      ]

      const dataset = labelDetails.map(detail => {
        const tempData = subAssets.map(subAsset => {
          return data[subAsset][detail.rating]
        })

        return {
          label: detail.label,
          data: tempData,
          backgroundColor: detail.backgroundColor,
        }
      })

      return dataset
    },
    hazardData() {
      return {
        labels: [
          'Bushfire',
          'Drought',
          'Flooding',
          'Heatwaves',
          'Increased Rainfall Intensity',
          'Sea Level Rise',
          'Storms',
          'Extreme Heat',
        ],
        datasets: this.hazardDataSet
      }
    },
    subAssetDataSet() {
      // initialize data
      const riskRatings = {
        no_rating: 0,
        very_low: 0,
        low: 0,
        moderate: 0,
        high: 0,
        very_high: 0,
      }
      const data = {
        electrical: structuredClone(riskRatings),
        exterior_enclosure: structuredClone(riskRatings),
        fire_protection: structuredClone(riskRatings),
        hvac: structuredClone(riskRatings),
        interior_construction: structuredClone(riskRatings),
        plumbing: structuredClone(riskRatings),
        site_electrical_utilities: structuredClone(riskRatings),
        site_improvement: structuredClone(riskRatings),
        superstructure: structuredClone(riskRatings),
        site_mechanical_utilities: structuredClone(riskRatings),
        conveying: structuredClone(riskRatings),
        roofing: structuredClone(riskRatings),
        rooftops: structuredClone(riskRatings),
        interior_finishes: structuredClone(riskRatings),
        car_parking: structuredClone(riskRatings),
        equipment: structuredClone(riskRatings),
      }

      let field = "lt_climate_risk_rating_code"
      if (this.selectedSubAssetChartTerm === "st") {
        field = "st_climate_risk_rating_code"
      }

      // populate data
      this.initialCRAList.forEach(cra => {
        const ratings = Object.keys(riskRatings)
        // remove first one "no_rating"
        ratings.shift()

        // check if sub asset type exists
        if (data[cra.sub_asset_type_code]) {
          // check if risk assessment rating exists
          if (ratings.includes(cra[field])) {
            data[cra.sub_asset_type_code][cra[field]] ++
          } else {
            data[cra.sub_asset_type_code].no_rating ++
          }
        }
      });

      const labelDetails = [
        { label: "No Rating", rating: "no_rating", backgroundColor: "#6C757D" },
        { label: "Very Low", rating: "very_low", backgroundColor: "#46D267" },
        { label: "Low", rating: "low", backgroundColor: "#28A745" },
        { label: "Moderate", rating: "moderate", backgroundColor: "#FFC107" },
        { label: "High", rating: "high", backgroundColor: "#FF9900" },
        { label: "Very High", rating: "very_high", backgroundColor: "#DD4B39" },
      ]
      const subAssets = [
        "electrical",
        "exterior_enclosure",
        "fire_protection",
        "hvac",
        "interior_construction",
        "plumbing",
        "site_electrical_utilities",
        "site_improvement",
        "superstructure",
        "site_mechanical_utilities",
        "conveying",
        "roofing",
        "rooftops",
        "interior_finishes",
        "car_parking",
        "equipment",
      ]

      const dataset = labelDetails.map(detail => {
        const tempData = subAssets.map(subAsset => {
          return data[subAsset][detail.rating]
        })

        return {
          label: detail.label,
          data: tempData,
          backgroundColor: detail.backgroundColor,
        }
      })

      return dataset
    },
    subAssetData() {
      return {
        labels: [
          "Electrical",
          "Exterior Enclosure",
          "Fire Protection",
          "HVAC",
          "Interior Construction",
          "Plumbing",
          "Site Electrical Utilities",
          "Site Improvement",
          "Superstructure",
          "Site Mechanical Utilities",
          "Conveying",
          "Roofing",
          "Rooftops",
          "Interior Finishes",
          "Car Parking",
          "Equipment",
        ],
        /* dataset for doughnut
        datasets: [
          {
            backgroundColor: [
              "#F66D9B",
              "#9561E2",
              "#6574CD",
              "#E3352F",
              "#F6993F",
              "#FFED4A",
              "#38C171",
              "#4DC0B5",
              "#3490DC",
            ],
            data: this.subAssetDataSet,
          }
        ],
        */
        datasets: this.subAssetDataSet,
      }
    },
    hazardCombinedDataSet() {
      const backgroundColor = ['#FFEE4C', '#9660E6', '#FA9939', '#F66D9B', '#4BBFB1', '#328FDD', '#3EBF6E']
      const data = {
        bushfire: 0,
        drought: 0,
        flooding: 0,
        heatwaves: 0,
        increased_rainfall_intensity: 0,
        sea_level_rise: 0,
        storms: 0,
        extreme_heat: 0,
      }
      let total = 0

      let field = "lt_climate_risk_rating_code"
      if (this.selectedHazardCombinedChartTerm === "st") {
        field = "st_climate_risk_rating_code"
      }

      this.initialCRAList.forEach(cra => {
        if (["moderate", "high", "very_high"].includes(cra[field])) {
          cra.climate_variables.forEach(climateVariable => {
            data[climateVariable] ++
            total ++
          })
        }
      });

      return [
        {
          backgroundColor,
          data: Object.values(data).map(val => {
            if (total === 0) {
              return 0
            } else {
              return val
            }
          }),
        },
      ]
    },
    hazardCombinedData() {
      return {
        labels: [
          'Bushfire',
          'Drought',
          'Flooding',
          'Heatwaves',
          'Increased Rainfall Intensity',
          'Sea Level Rise',
          'Storms',
          'Extreme Heat',
        ],
        datasets: this.hazardCombinedDataSet
      }
    },
    riskRatingChangesDataset() {
      const startFields = [
        "very_low_start",
        "low_start",
        "moderate_start",
        "high_start",
        "very_high_start",
      ]
      const endFields = [
        "very_low_end",
        "low_end",
        "moderate_end",
        "high_end",
        "very_high_end",
      ]

      // initialize data
      const data = []
      startFields.forEach(start => {
        const tempArr = endFields.map(end => {
          return {
            from: start, to: end, flow: 0
          }
        })

        data.push(...tempArr)
      })

      this.initialCRAList.forEach(cra => {
        const index = data.findIndex(datum => {
          return datum.from === `${cra.st_climate_risk_rating_code}_start`
            && datum.to === `${cra.lt_climate_risk_rating_code}_end`
        })

        if (index !== -1) {
          data[index].flow += 1
        }
      });

      const finalData = []
      data.forEach(datum => {
        if (datum.flow) {
          finalData.push(datum)
        }
      })

      return finalData
    },
    riskRatingChangesData() {
      const colors = {
        very_low_start: "#46D267",
        very_low_end: "#46D267",
        low_start: "#28A745",
        low_end: "#28A745",
        moderate_start: "#FFC107",
        moderate_end: "#FFC107",
        high_start: "#FF9900",
        high_end: "#FF9900",
        very_high_start: "#DD4B39",
        very_high_end: "#DD4B39",
      };
      const getColor = (key) => colors[key];

      return  {
        datasets: [{
          data: this.riskRatingChangesDataset,
          colorFrom: (c) => getColor(c.dataset.data[c.dataIndex]?.from || 0),
          colorTo: (c) => getColor(c.dataset.data[c.dataIndex]?.to || 0),
          priority: {
            very_low_start: 0,
            very_low_end: 1,
            low_start: 2,
            low_end: 3,
            moderate_start: 4,
            moderate_end: 5,
            high_start: 6,
            high_end: 7,
            very_high_start: 8,
            very_high_end: 9,
          },
          labels: {
            very_low_start: "Very Low",
            very_low_end: "Very Low",
            low_start: "Low",
            low_end: "Low",
            moderate_start: "Moderate",
            moderate_end: "Moderate",
            high_start: "High",
            high_end: "High",
            very_high_start: "Very High",
            very_high_end: "Very High",
          }
        }
      ]}
    },
    hazardPieDataSet() {
      const backgroundColor = ['#FFEE4C', '#9660E6', '#FA9939', '#F66D9B', '#4BBFB1', '#328FDD', '#3EBF6E']
      const climateVariables = {
        bushfire: 0,
        drought: 0,
        flooding: 0,
        heatwaves: 0,
        increased_rainfall_intensity: 0,
        sea_level_rise: 0,
        storms: 0,
        extreme_heat: 0,
      }
      const data = {
        moderate: structuredClone(climateVariables),
        high: structuredClone(climateVariables),
        very_high: structuredClone(climateVariables),
      }

      this.initialCRAList.forEach(cra => {
        if (["moderate", "high", "very_high"].includes(cra.lt_climate_risk_rating_code)) {
          cra.climate_variables.forEach(climateVariable => {
            data[cra.lt_climate_risk_rating_code][climateVariable] ++
          })
        }
        if (["moderate", "high", "very_high"].includes(cra.st_climate_risk_rating_code)) {
          cra.climate_variables.forEach(climateVariable => {
            data[cra.st_climate_risk_rating_code][climateVariable] ++
          })
        }
      });

      return [
        {
          backgroundColor,
          data: Object.values(data.moderate),
        },
        {
          backgroundColor,
          data: Object.values(data.high),
        },
        {
          backgroundColor,
          data: Object.values(data.very_high),
        }
      ]
    },
    hazardPieData() {
      return {
        labels: [
          'Bushfire',
          'Drought',
          'Flooding',
          'Heatwaves',
          'Increased Rainfall Intensity',
          'Sea Level Rise',
          'Storms',
          'Extreme Heat'
        ],
        datasets: this.hazardPieDataSet
      }
    },
    adaptationActionDataSet() {
      const data = {
        com_edu_eng: 0,
        eng_solutions: 0,
        hazard_investigation: 0,
        ops_management: 0,
        relocation_avoidance: 0,
      }

      // loop through climate risks
      this.initialCRAList.forEach(cra => {
        // loop through risk adaptations
        cra.risk_adaptations?.forEach(adaptation => {
          if (!adaptation.is_implemented) {
            data[adaptation.adaptation_category_code] ++
          }
        })
      })

      return Object.values(data)
    },
    adaptationActionData() {
      return {
        labels: [
          "Communication, education and engagement",
          "Engineering solutions",
          "Hazard investigation",
          "Operational management",
          "Relocation and avoidance",
        ],
        datasets: [
          {
            backgroundColor: ['#FFEE4C', '#9660E6', '#FA9939', '#F66D9B', '#4BBFB1'],
            data: this.adaptationActionDataSet,
          }
        ]
      }
    },
    adaptationActionTable() {
      const implementationTiming = {
        "Very high priority (<1 year)": { implemented: 0, notImplemented: 0 } ,
        "High priority (1-5 years)": { implemented: 0, notImplemented: 0 } ,
        "Medium priority (5-10 year)": { implemented: 0, notImplemented: 0 } ,
        "Low priority (10-20 years)": { implemented: 0, notImplemented: 0 } ,
        "Very low priority (20+ years)": { implemented: 0, notImplemented: 0 } ,
      }

      this.initialCRAList?.forEach(cra => {
        cra.risk_adaptations?.forEach(adaptation => {
          if(!implementationTiming[adaptation.adaptation_timing_label]){
            return
          }
          if (adaptation.is_implemented) {
            implementationTiming[adaptation.adaptation_timing_label].implemented ++
          } else {
            implementationTiming[adaptation.adaptation_timing_label].notImplemented ++
          }
        })
      })

      const data = []
      Object.entries(implementationTiming).forEach(([key, value]) => {
        const total = value.implemented + value.notImplemented
        const percentage = value.implemented ? value.implemented / total * 100 : 0
        const tempData = {
          timing: key,
          count: total,
          implemented: value.implemented,
          percent: Math.round((percentage + Number.EPSILON) * 100) / 100,
        }

        data.push(tempData)
      })

      return data
    },
    riskRatingByConsequenceDataSet() {
      // initialize data
      const riskRatings = {
        no_rating: 0,
        very_low: 0,
        low: 0,
        moderate: 0,
        high: 0,
        very_high: 0,
      }
      const data = {
        customer: structuredClone(riskRatings),
        financial: structuredClone(riskRatings),
        probity: structuredClone(riskRatings),
        regulatory: structuredClone(riskRatings),
        reputation: structuredClone(riskRatings),
        safety: structuredClone(riskRatings),
        workforce: structuredClone(riskRatings),
      }
      
      let field = "lt_climate_risk_rating_code"
      if (this.selectedRiskRatingByConsequenceChartChartTerm === "st") {
        field = "st_climate_risk_rating_code"
      }

      // populate data
      this.initialCRAList.forEach(cra => {
        const ratings = Object.keys(riskRatings)
        // remove first one "no_rating"
        ratings.shift()

        // loop through consequence areas
        cra.consequence_areas.forEach(consequenceArea => {
          if (ratings.includes(cra[field])) {
            data[consequenceArea][cra[field]] ++
          } else if (data[consequenceArea]) {
            data[consequenceArea].no_rating ++
          }
        })
      });

      const labelDetails = [
        { label: "No Rating", rating: "no_rating", backgroundColor: "#6C757D" },
        { label: "Very Low", rating: "very_low", backgroundColor: "#46D267" },
        { label: "Low", rating: "low", backgroundColor: "#28A745" },
        { label: "Moderate", rating: "moderate", backgroundColor: "#FFC107" },
        { label: "High", rating: "high", backgroundColor: "#FF9900" },
        { label: "Very High", rating: "very_high", backgroundColor: "#DD4B39" },
      ]
      const subAssets = [
        "customer",
        "financial",
        "probity",
        "regulatory",
        "reputation",
        "safety",
        "workforce",
      ]

      const dataset = labelDetails.map(detail => {
        const tempData = subAssets.map(subAsset => {
          return data[subAsset][detail.rating]
        })

        return {
          label: detail.label,
          data: tempData,
          backgroundColor: detail.backgroundColor,
        }
      })

      return dataset
    },
    riskRatingByConsequenceData() {
      return {
        labels: [
          'Customer',
          'Financial',
          'Probity',
          'Regulatory',
          'Reputation',
          'Safety',
          'Workforce',
        ],
        datasets: this.riskRatingByConsequenceDataSet
      }
    },
  },
  methods: {
    cellClass({ row, column }) {
      if (column.property === "percent") {
        if (row.percent < 30) {
          return "text-danger fw-bold"
        } else if (row.percent < 70) {
          return "text-warning fw-bold"
        } else {
          return "text-success fw-bold"
        }
      } else if (column.property === "count") { 
        return "fw-bold"
      } else if (column.property === "implemented") {
        return "fw-bold text-center"
      }
    }
  },
}
</script>

<style scoped>
.small-chart {
  max-width: 300px;
  margin:  8px auto;
}

.wide-chart {
  max-width: 1800px;
  margin:  8px auto;
}

.arc-primary-font{
  color: #0C0808
}
.arc-orange-font{
  color: #E4610F
}

.el-collapse {
  border: 0;
}

.adaptation-table-title {
  font-size: 15px;
  font-weight: bold;
  color: rgb(104, 104, 104);
}

.adaptation-table-card {
  height: 390px;
}

.timing-column {
  font-size: 12px;
}

.sub-asset-chart {
  width: 450px !important;
  max-width: 450px !important;
}

.sub-asset-chart-container {
  margin-left: 55px;
}
</style>